import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import paloma from '@astina/paloma-common-ui/src/services/PalomaBackend';
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import trans from '@astina/paloma-common-ui/src/services/Translator';
export function deleteUser(userId) {
    return new DeleteUser(userId).enqueue();
}
export default class DeleteUser extends AbstractCommand {
    userId;
    constructor(userId) {
        super();
        this.userId = userId;
    }
    execute() {
        return paloma
            .execute(this.name(), { userId: this.userId })
            .then(user => {
            alerts.success(trans(`command.${this.name()}.success`));
            return user;
        })
            .catch(error => {
            alerts.error(trans(`command.${this.name()}.error`));
            throw error;
        });
    }
    name() {
        return "delete_user";
    }
    needsConfirmation() {
        return true;
    }
    isDangerous() {
        return true;
    }
    icon() {
        return 'delete';
    }
    requiresPermission() {
        return 'PORTAL_USERS_MANAGE';
    }
}
